/**
 * Column width constants for data grid columns
 * Centralized object for all column width values used across the application
 */
export const columnWidths = {
  // Identifier columns
  idShort: 120,
  idLong: 250,
  siteId: 40,

  // Standard data columns (from smallest to largest)
  actions: 75,
  small: 90,
  mediumSmall: 100,
  latLon: 110,
  standard: 120,
  zone: 120,
  sensor: 120,
  medium: 140,
  mediumLarge: 150,
  large: 160,

  // Specific content type columns
  date: 170,
  datetime: 180,
  name: 200,
  link: 220,
  address: 360
} as const;
